{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Double Drop",
  "alternateName": [
    "cs go double", "cs2 double", "double drop cs", "cs double drop", "csgo double drop",
    "cs go double drop", "double drop cs go", "double drop cs2"
  ],
  "description": "A betting game where players choose colors to double their bet.",
  "url": "https://6cs.fail/en/double"
}
